import request from "@/utils/request";
//------------积分商城查询接口
//获取积分列表查询
export const lntegralqueryApi = (date) => {
  return request({
    url: "/api/pointsmall/commRedemption/list",
    method: "POST",
    params: date
  })
}
//作废积分接口
export const wastebtnqueryApi = (date) => {
  return request({
    url: "/api/pointsmall/commRedemption/discard",
    method: "POST",
    params: date
  })
}
//查看详情接口
export const wastebtnquerychak = (date) => {
  return request({
    url: "/api/pointsmall/commRedemption/detail",
    method: "POST",
    params: date
  })
}
export const toviewuserApi = (date) => {
  return request({
    url: "/api/cust/detail",
    method: "POST",
    params: date
  })
}
//查看礼物主数据sku
export const reserveGIftSku = (date) => {
  return request({
    url: "/api/pointsmall/reserveGIft/viewSku",
    method: "POST",
    params: date
  })
}

//劵包查看详情
export const couppacketView = (date) => {
  return request({
    url: "/api/coupons/couppacket/view",
    method: "POST",
    params: date
  })
}
//劵包列表
export const couppacketJuan = (date) => {
  return request({
    url: "/api/coupons/couppacket/list",
    method: "POST",
    params: date
  })
}


//--------------积分商城礼物主数据接口
//礼物主数据tab列表
export const reserveGIftApi = (date) => {
  return request({
    url: "/api/pointsmall/reserveGIft/list",
    method: "POST",
    params: date
  })
}
//礼物主数据tab列表-查看
export const reserveGIfSeetApi = (date) => {
  return request({
    url: "/api/pointsmall/reserveGIft/view",
    method: "POST",
    params: date
  })
}
// 礼物主数据tab列表删除
export const reserveGIfSeetdelete = (date) => {
  return request({
    url: "/api/pointsmall/reserveGIft/delete",
    method: "POST",
    params: date
  })
}
// 礼物主数据tab列表启用/禁用
export const reserveGIfSeetenable = (date) => {
  return request({
    url: "/api/pointsmall/reserveGIft/enable",
    method: "POST",
    params: date
  })
}


// 礼物主数据tab列表新增
export const reserveGIfSeetinsert = (params, data) => {
  return request({
    url: `/api/pointsmall/reserveGIft/insert?
    &giftName=${params.giftName}&giftKind=${params.giftKind}
    &remark=${params.remark}&giftUnit=${params.giftUnit}`,
    method: "POST",
    data: data
  })
}
// 礼物主数据tab列表修改
export const reserveGIfSeetupdate = (params, data) => {
  return request({
    url: `/api/pointsmall/reserveGIft/update?&giftName=${params.giftName}
    &giftUnit=${params.giftUnit}&remark=${params.remark}&giftID=${params.giftID}&giftKind=${params.giftKind}`,
    method: "POST",
    data: data
  })
}

// 礼物主数据获取Sku列表
export const reserveGIfSeetSku = (date) => {
  return request({
    url: "/api/product/getSkuList",
    method: "POST",
    params: date
  })
}
// 礼物主数据导入
export const lntegralquerydaoru = (data) => {
  return request({
    url: "/api/pointsmall/importReservegiftExcel",
    method: "POST",
    data: data
  })
}
// 礼物主数据产品信息详情
export const detailedCapi = (date) => {
  return request({
    url: `/api/product/queryBySku`,
    method: "POST",
    params: date
  })
}
//----------积分商城商城商品接口
//积分商城中心表格数据接口
export const commodityApi = (date) => {
  return request({
    url: "/api/pointsmall/commodity/list",
    method: "POST",
    params: date
  })
}
//积分商城删除功能接口
export const commoditydelete = (date) => {
  return request({
    url: "/api/pointsmall/commodity/delete",
    method: "POST",
    params: date
  })
}
//积分商城上架下架功能接口
export const upperOrLowerApi = (date) => {
  return request({
    url: "/api/pointsmall/commodity/upperOrLower",
    method: "POST",
    params: date
  })
}
//积分商城新增接口
export const upperOrLowerinsert = (data) => {
  return request({
    url: "/api/pointsmall/commodity/insert",
    method: "POST",
    data: data
  })
}
//积分商城新查看接口
export const upperOrLowerview = (date) => {
  return request({
    url: "/api/pointsmall/commodity/view",
    method: "POST",
    params: date
  })
}
//选择劵库接口
export const couponsGroupApi = (date) => {
  return request({
    url: "api/coupons/couponsGroup/list",
    method: "POST",
    params: date
  })
}
//积分商城修改接口
export const commodityupdateAip = (date) => {
  return request({
    url: "/api/pointsmall/commodity/update",
    method: "POST",
    data: date
  })
}
//图片上传
export const imageupadatApi = (date) => {
  return request({
    url: "/api/uploadImg?type=2",
    method: "POST",
    data: date
  })
}
//会员等级数据
export const customerlevelApi = (date) => {
  return request({
    url: "/api/Custlvl/querySelect",
    method: "POST",
    params: date
  })
}

// 积分兑换导出
export const redemptionReportExportApi = (data) =>{
  return request({
    url:"/api/report/redemptionReportExport",
    method: "POST",
    data: data
  })
}